const canUserAccess = (user, reqPage, query) => {
    if (!user) {
        return false;
    }
    const {
        permission: { manageUsers, manageSurgeons, manageEntities },
        userGroups,
        userStudies,
        userSites,
        userSurgeons
    } = user;
    let allow = false;
    switch (reqPage) {
        case '/test-me':
            allow = true;
            break;
        case '/':
            if (user.userType === 'User' || user.userType === 'SSSF Administrator') {
                allow = true;
            }
            break;
        case '/admin':
            if (user.userType === 'SSSF Administrator') {
                allow = true;
            }
            break;

        case '/embedded-reports':
            if (user.userType === 'SSSF Administrator') {
                allow = true;
            }
            break;

        case '/import':
            if (manageEntities) {
                allow = true;
                break;
            }
            if (userGroups.some((group) => group.admin && group.status === 'active')) {
                allow = true;
                break;
            }
            if (userStudies.some((study) => study.admin && study.status === 'active')) {
                allow = true;
                break;
            }
            if (userSites.some((site) => site.admin && site.status === 'active')) {
                allow = true;
                break;
            }
            break;
        case '/export':
            if (manageEntities) {
                allow = true;
                break;
            }
            if (userGroups.some((group) => group.admin && group.status === 'active')) {
                allow = true;
                break;
            }
            if (userStudies.some((study) => study.admin && study.status === 'active')) {
                allow = true;
                break;
            }
            if (userSites.some((site) => site.admin && site.status === 'active')) {
                allow = true;
                break;
            }
            break;
        case '/sites':
        case '/patients':
        case '/entries':
        case reqPage.startsWith('/entries/'):
            if (manageEntities 
                || userGroups.length
                || userStudies.length
                || userSites.length) allow = true; 
            break;
        case '/form':
            if (manageEntities) {
                allow = true;
                break;
            }
            if (userGroups.some((group) => group.admin && group.status === 'active')) {
                allow = true;
                break;
            }
            if (userStudies.some((study) => study.admin && study.status === 'active')) {
                allow = true;
                break;
            }
            break;
        case '/users':
        case reqPage.startsWith('/user'): 
            if (manageUsers) allow = true;
            break;
        case '/surgeons':
            if (manageEntities 
                || manageSurgeons 
                || userSurgeons.length) allow = true;
            break;
        case '/study-groups':
            if (manageEntities 
                || userGroups.length) allow = true;
            break;
        case '/studies':
            if (manageEntities 
                || userGroups.length 
                || userStudies.length) allow = true;
            break;
        case '/dashboards':
            if (user.tableau 
                || userGroups.length) allow = true;
            break;
        case '/patient-types':
            if (manageEntities) allow = true;
            break;
        case reqPage.startsWith('/form'):
        case '/form/templates':
            if (user.userType === 'SSSF Administrator') {
                allow = true;
            }
            break;
        case reqPage.startsWith('/my-account'):
            allow = true;
            break;
        default:
            allow = true;
            break;
    }
    return allow;
};

export default canUserAccess;
